<template>
  <div class="">
    <div class="text-center" style="white-space: nowrap">
      <v-btn
        icon
        :disabled="modelValue <= marketingValues.min"
        :loading="loading"
        @click="updateHandler('decrease')"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <MarketingPushChip :value="modelValue" />
      <v-btn
        icon
        :disabled="modelValue >= marketingValues.max"
        :loading="loading"
        @click="updateHandler('increase')"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { IMarketingValues, marketingValues } from '@/bundles/Common/types/marketing';

import MarketingPushChip from '@/bundles/Common/components/marketing/MarketingPushChip.vue';

interface IPriorityFieldData {
  marketingValues? : IMarketingValues;
}

export default defineComponent({
  name: 'PriorityField',

  components: { MarketingPushChip },

  props: {
    modelValue: {
      type: Number,
      default: 1
    },
    active: Boolean,
    loading: Boolean
  },

  emits: ['update:modelValue'],

  data: (): IPriorityFieldData => ({}),

  created () {
    this.marketingValues = marketingValues;
  },

  methods: {
    updateHandler (action: 'decrease' | 'increase') {
      let newPriorityValue = this.modelValue;
      newPriorityValue = action === 'decrease' ? Math.max(--newPriorityValue, this.marketingValues!.min) : Math.min(++newPriorityValue, this.marketingValues!.max);

      this.$emit('update:modelValue', newPriorityValue);
    }
  }
})
</script>
